import React, { useEffect } from "react";
import "./index.scss";

export const RightToggler = ({title, children, size, close, arrow = false}) => {
  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <>
      <div className="right-toggler-backdrop active" onClick={close} />
      <div className={"right-toggler active"} style={{maxWidth: size}}>
        <div className="toggler-title">
          <span className={arrow ? "arrow-active" : ""}>{title}</span>
          <button onClick={close} className="toggle-close">
            &times;
          </button>
        </div>
        <div className="body">{children}</div>
      </div>
    </>
  );
};
